/* eslint-disable max-len */
import { getFontColorFromHSL } from 'library/common-styles';
import { ThemeType } from '../../theme/jss-types';

export const addressBookStyles = (theme: ThemeType) => ({
    main: {
        width: '100%',
        padding: '5px 6px 6px 3px',
        height: '100%',
    },
    filters: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
    },
    filter: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: 24,
    },
    cellValue: {
        color: '#111111',
        fontFamily: 'Open Sans',
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 0,
        cursor: 'pointer',
        wordWrap: 'break-word',
        whiteSpace: 'break-spaces',
    },
    cellNa: {
        color: '#999999',
        fontFamily: 'Open Sans',
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 0,
    },
    extraFilters: {
        width: '100%',
        borderRadius: '0 2px 0 0',
        backgroundColor: '#FFFFFF',
        padding: '8px 16px',
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 4,
    },
    leftFilters: {
        display: 'flex',
        alignItems: 'center',
    },
    rightFilters: {
        display: 'flex',
        alignItems: 'center',
        '& .ant-btn': {
            boxSizing: 'border-box',
            height: 32,
            borderRadius: 4,
            fontFamily: 'Open Sans',
            fontSize: 12,
            fontWeight: 600,
            laterSpacing: 0,
        },
        '& .ant-btn-ghost': {
            border: `1px solid ${theme.primaryColor}`,
            color: getFontColorFromHSL(theme.secondaryFillColor),
        },
        '& .ant-btn-primary, .ant-btn-primary:hover, .ant-btn-primary:focus': {
            backgroundColor: theme.primaryColor,
            color: getFontColorFromHSL(theme.secondaryFillColor),
        },
    },
    downloadBtn: {
        marginRight: 8,
        color: getFontColorFromHSL(theme.secondaryFillColor),
    },
    newAddressBtn: {
        marginRight: 8,
    },
    modal: {
        '& .ant-modal-header': {
            backgroundColor: theme.primaryColor,
            borderRadius: '4px 4px 0 0',
            padding: '16px 24px',
        },
        '& .ant-modal-title, .ant-modal-close-x': {
            color: '#FFFFFF',
        },
        '& .ant-modal-content': {
            borderRadius: 4,
        },
        '& .ant-modal-body': {
            padding: 24,
            marginTop: -30,
        },
        '& .ant-btn-primary': {
            fontSize: 12,
            fontWeight: 600,
        },
    },
    searchInput: {
        width: '100%',
        borderRadius: '6px !important',
    },
    footer: {
        height: 32,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#F7F7F7',
        '& .ant-select:not(.ant-select-customize-input) .ant-select-selector': {
            backgroundColor: '#fafafa',
            height: '22px !important',
        },
    },
    paginationGroup: {
        direction: 'ltr',
        display: 'flex',
        fontSize: 12,
    },
    resultPerPage: {
        margin: '0 5px !important',
        '& .ant-select:not(.ant-select-customize-input) .ant-select-selector': {
            backgroundColor: '#fafafa',
        },
        '& .ant-select-selector': {
            width: 'auto !important',
            borderRadius: '6px !important',
            alignItems: 'center',
            fontSize: 12,
        },
        '& .ant-select-dropdown': {
            padding: '12px !important',
            borderRadius: '6px !important',
            gap: '16px !important',
        },
        '& .ant-select-item': {
            padding: '8px !important',
            borderRadius: '4px !important',
            gap: '10px !important',
            fontWeight: 550,
        },
        '& .ant-select-item-option-selected': {
            backgroundColor: `${theme.tertiaryFillColor} !important`,
            color: getFontColorFromHSL(theme.tertiaryFillColor),
            padding: '8px !important',
            borderRadius: '4px !important',
            gap: '10px !important',
        },
        '& .ant-select-selection-item': {
            fontWeight: '550 !important',
        },
    },
});
